import FeatureLinking from "components/feature-entity-linking-page";
import { FeatureTypes } from "entity-app/constants";
import { useLocation } from "react-router-dom";

function FeatureMaterialLinking() {
  const { state } = useLocation() as { state: any };
  const isBulkLinking = state?.selectedRows?.length > 1;
  const leftTabEntityTypes = [FeatureTypes.ACTIVITIES, FeatureTypes.SUBMITTALS];
  if (!isBulkLinking) {
    leftTabEntityTypes.push(FeatureTypes.MATERIALS);
  }
  return (
    <FeatureLinking
      featureTypeId={FeatureTypes.MATERIALS}
      leftTabEntityTypes={leftTabEntityTypes}
      state={state}
    />
  );
}

export default FeatureMaterialLinking;
